import { Component } from "@angular/core";

@Component({
  selector: "app-card-verify",
  templateUrl: "./card-verify.component.html",
  styleUrls: ["./card-verify.component.scss"]
})
export class CardVerifyComponent {}
